// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const buttonSizeVariants = {
    small: {
        height: 28,
        fontSize: 11,
        padding: "0 20px",
        icon: 16,
        iconPadding: 6,
        lineHeight: "16px",
    },
    medium: {
        height: 32,
        fontSize: 12,
        padding: "0 24px",
        icon: 16,
        iconPadding: 6,
        lineHeight: "17px",
    },
    large: {
        height: 42,
        fontSize: 14,
        padding: "0 32px",
        icon: 16,
        iconPadding: 6,
        lineHeight: "20px",
    },
};

export default buttonSizeVariants;
